import { render, staticRenderFns } from "./app-landing.vue?vue&type=template&id=2d8a7d8b&scoped=true&"
import script from "./app-landing.vue?vue&type=script&lang=js&"
export * from "./app-landing.vue?vue&type=script&lang=js&"
import style0 from "./app-landing.vue?vue&type=style&index=0&id=2d8a7d8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8a7d8b",
  null
  
)

export default component.exports